import { snakeCase } from "es-toolkit/compat";

export function pushEvent(name: string, params: Record<string, unknown> = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: name,
    ...params,
  });
}

export function pushUniversalEvent(name: string, params: Record<string, unknown> = {}) {
  const normalized = Object.fromEntries(
    Object.entries(params).map(([key, value]) => [snakeCase(key), value]),
  );
  pushEvent("universal_event", {
    universal_event_name: name,
    params: normalized,
  });
}
